import { draftClaimLineItemContext } from '~/app/features/crew/claim-line-items/claimLineItemMiddleware';
import { crewClaimContext } from '~/app/features/crew/crewClaimMiddleware';
import { crewOrderContext } from '~/app/features/order-middleware/orderMiddleware';
import { settingsContext } from '~/app/settingsMiddleware';
import api from '~/utils/api';
import { makeAction, makeLoader, redirect } from '~/utils/routing';

export const { loader, useLoaderData } = makeLoader(({ context }) => {
  const { storeSlug: store } = context.get(settingsContext);
  const { claimType } = context.get(crewClaimContext);
  const { reasonPolicy } = context.get(draftClaimLineItemContext);
  const order = context.get(crewOrderContext);

  return reasonPolicy
    ? {
        reasonPolicy,
        orderId: order.idFromPlatform,
        claimType,
        store,
      }
    : // return a redirect with the event custom fields if it exists
      redirect('../meta');
});

export const { action, useActionResult } = makeAction(
  ({ context }, appStore) => {
    const { storefrontId } = context.get(settingsContext);
    const draftClaimLineItem = context.get(draftClaimLineItemContext);

    return api
      .confirmAfterReasonSelection({
        params: { storefrontId },
        query: {
          originalStoreOrderLineItemId: draftClaimLineItem.lineItem.id,
        },
      })
      .then(() => {
        // item not eligible for return
        appStore.dispatch(
          appStore.actions.invalidateLineItem(draftClaimLineItem.id),
        );

        return {
          ok: true,
        };
      })
      .catch(() => ({ ok: false }));
  },
);

// the action clears the draft claim line item, so we don't want to revalidate the loader
export const shouldRevalidate = () => false;
